<template src="./EmployerComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {AppConstant, CommonText} from "@/supports/app.constant";
import {ref, onMounted, computed, reactive, watch} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import {useRouter} from "vue-router";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import SelectCustom from "@/components/inputs/select/custom/SelectCustom.vue";
import LoadingComponent from "@/components/loading/LoadingComponent.vue";
import ModalProductImportComponent from "@/components/modals/modal-product-import/ModalProductImportComponent.vue";
import ModalProductExportComponent from "@/components/modals/modal-export/ModalExportComponent.vue";
import ModalExportComponent from "@/components/modals/modal-export/ModalExportComponent.vue";
import TabDeliveryOwnerComponent
  from "@/pages/invoice/delivery-data/list-exchange-delivery/tab-exchange/tab-delivery-owner/TabDeliveryOwnerComponent.vue";
import {useEmployerStore} from "@/stores/employer.js";
import {useStore} from "@/stores/store.js";

export default {
  name: 'EmployerComponent',
  components: {
    TabDeliveryOwnerComponent,
    ModalExportComponent,
    ModalProductExportComponent, ModalProductImportComponent, LoadingComponent,
    SelectCustom,
    InputCheckboxOne,
    PaginateComponent,
    ButtonAddComponent,
    IconTrash,
    IconEdit,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome
  },
  setup() {
    const dataHeaderTable = ref({
      companyName: {
        label: 'Tên Nhân Viên',
        order: 2,
        width: '20%',
      },
      employerRole: {
        label: 'Chức Vụ',
        order: 3,
        width: '15%',
      },
      companyEmail: {
        label: 'Email',
        order: 4,
        width: '15%',
      },
      companyPhone: {
        label: 'Số điện thoại',
        order: 5,
        width: '10%',
      },
      companyStatus: {
        label: 'Làm Việc Tại Cửa Hàng (Nếu Có)',
        order: 6,
        width: '20%',
      },
    })
    const checkAll = ref(false)
    const location = ref('Nhân Viên')
    const table = ref('employer')
    const labelButtonSearch = ref('Tìm kiếm')
    const labelButtonInvite = ref('Thêm Mới')
    const urlOrigin = ref('/employers')
    const dataSearch = ref({
      employer_name: {
        id: 'employer_name',
        label: 'Tên nhân viên',
        placeholder: 'Tên nhân viên',
        value: ''
      },
      employer_role: {
        id: 'employer_role',
        label: 'Chức Vụ',
        placeholder: 'Chức Vụ',
        value: '',
        options: []
      },
      employer_email: {
        id: 'employer_email',
        label: 'Email Nhân Viên',
        placeholder: 'Email Nhân Viên',
        value: ''
      },
      employer_phone: {
        id: 'employer_phone',
        label: 'Số điện thoại',
        placeholder: 'Số điện thoại',
        value: ''
      },
      employer_store_id: {
        id: 'employer_store_id',
        label: 'Cửa hàng',
        placeholder: 'Cửa hàng',
        value: '',
        error: '',
        isError: false,
        required: false,
        options: []
      },
    })
    const checkItems = ref({})
    const selectAction = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_COMMON))
    const selectLimitPage = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_PAGE))
    const isLoading = ref(false)
    const listItemSelected = ref([])
    const messError = ref('')
    const employerStore = useEmployerStore()
    const storeCompStore = useStore()
    const accountStore = useAccountStore()
    const router = useRouter()

    onMounted(() => {
      getListStore();
      getAllowedRoles();
      getListEmployer(router.currentRoute.value.query.page ?? 1);
    });

    const listEmployers = computed(() => {
      return employerStore.employers;
    });

    const paginate = computed(() => {
      return employerStore.paginate;
    });

    function emitPage(page) {
      getListEmployer(page);
    }

    function redirectToInvite() {
      router.push('/employer/create')
    }

    async function getListEmployer(page, take = 10) {
      const params = {
        company_id: accountStore.account.company.id,
        m_user_id: CommonService.getUserId(),
        employer_name: dataSearch.value.employer_name.value,
        employer_email: dataSearch.value.employer_email.value,
        employer_phone: dataSearch.value.employer_phone.value,
        employer_role: dataSearch.value.employer_role.value,
        employer_store_id: dataSearch.value.employer_store_id.value,
        page: page,
        take: take,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/employer/employer-list-limit';
      await employerStore.getListEmployerWithLimit(url, params);
    }

    async function getListStore() {
      const params = {
        company_id: accountStore.account.company.id,
        m_user_id: CommonService.getUserId(),
      }

      const url = AppConstant.URL_API_LOCAL + 'api/v1/stores/list-store-by-role';
      await storeCompStore.getListStoreByRole(url, params);
    }

    async function getAllowedRoles() {
      const url = AppConstant.URL_API_LOCAL + 'api/v1/employer/allowed-create';
      const params = {
        company_id: accountStore.account.company.id,
        m_user_id: CommonService.getUserId(),
      };

      await employerStore.getAllowedRoles(url, params);
    }

    watch(
        () => employerStore.allowedRoles,
        (newAllowedRoles) => {
          if (newAllowedRoles && Array.isArray(newAllowedRoles)) {
            dataSearch.value.employer_role.options = newAllowedRoles;
          }
        }
    );

    watch(() => storeCompStore.storeByRoles, (newListStores) => {
      if(newListStores.length) {
        newListStores.forEach((item) => {
          dataSearch.value.employer_store_id.options.push({
            name: item.name,
            value: item.id
          })
        })
      }
    });

    watch(() => employerStore.employers, (newListEmployer) => {
      checkItems.value = {}
      newListEmployer.forEach((employer) => {
        if (checkItems.value[employer.id] === undefined) {
          checkItems.value[employer.id] = false
        }
      })
    });


    function showErrorMessage(mess) {
      messError.value = mess
    }

    function removeError() {
      messError.value = ''
    }

    function actionSelect(key) {
      if (listItemSelected.value.length === 0) {
        CommonService.showAlertPopup({
          title: 'Vui lòng chọn dữ liệu để thực hiện!',
          icon: "warning",
          showConfirmButton: false,
          timer: 1500,
          width: '800px'
        });
      } else {
        switch (parseInt(key)) {
          case AppConstant.ACTION_TYPE_DELETE:
            deleteEmployer();
            break;
        }
      }
    }

    async function deleteEmployer() {
      const params = {
        company_id: accountStore.account.company.id,
        employer_ids: listItemSelected.value,
      }

      const url = AppConstant.URL_API_LOCAL + 'api/v1/employer/delete';
      const employer = await employerStore.deleteEmployer(url, params);
      await CommonService.showAlertPopup({
        title: employer?.message,
        icon: employer?.status,
        showConfirmButton: false,
        timer: 1200,
        width: '800px'
      });
      await getListEmployer(router.currentRoute.value.query.page ?? 1);
    }

    function onChangeSelectItem(value, name) {
      checkItems.value[name] = value
      let counterChecked = 0
      listEmployers.value.forEach((employer) => {
        if(checkItems.value[employer.id]) {
          counterChecked++
        }
        if(value && listItemSelected.value.indexOf(employer.id) === -1 && parseInt(name) === parseInt(employer.id)) {
          listItemSelected.value.push(employer.id)
        }else if (!value && listItemSelected.value[employer.id]) {
          listItemSelected.value.splice(listItemSelected.value.indexOf(employer.id), 1);
        }
      })
      checkAll.value = false
      if(counterChecked === listEmployers.value.length) {
        checkAll.value = true
      }
    }

    function onChangeSelectAll(value) {
      checkAll.value = value
      for (const key in checkItems.value) {
        checkItems.value[key] = value
      }
      if(!value) {
        listItemSelected.value = []
      }else {
        listEmployers.value.forEach((employer) => {
          if(listItemSelected.value.indexOf(employer.id) === -1) {
            listItemSelected.value.push(employer.id)
          }
        })
      }
    }

    async function actionLimitPage(key) {
      switch (parseInt(key)) {
        case AppConstant.LIMIT_PAGE_10:
          await getListEmployer(1, AppConstant.LIMIT_PAGE_10);
          break;
        case AppConstant.LIMIT_PAGE_20:
          await getListEmployer(1, AppConstant.LIMIT_PAGE_20);
          break;
        case AppConstant.LIMIT_PAGE_50:
          await getListEmployer(1, AppConstant.LIMIT_PAGE_50);
          break;
      }
    }

    function searchEmployers() {
      getListEmployer(AppConstant.PAGE_DEFAULT);
    }

    function onChange(value, name) {
      dataSearch.value[name].value = value;
    }

    return {
      listEmployers,
      dataHeaderTable,
      labelButtonSearch,
      labelButtonInvite,
      dataSearch,
      paginate,
      urlOrigin,
      checkItems,
      selectAction,
      selectLimitPage,
      isLoading,
      listItemSelected,
      messError,
      location,
      table,
      emitPage,
      redirectToInvite,
      showErrorMessage,
      removeError,
      CommonService,
      CommonText,
      actionLimitPage,
      actionSelect,
      onChangeSelectItem,
      checkAll,
      onChangeSelectAll,
      searchEmployers,
      onChange
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 265px;
  height: 100%;

  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }

  .container-fluid {
    padding-top: 30px;

    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46, 35, 94, .07);

      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;

        .btn-invite-employer {
          width: 150px;
          margin-top: 50px;
        }

        .list-employers-component {
          margin-top: 30px;

          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }

          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;

            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }

          table {
            display: block;
            overflow-x: auto;
            white-space: nowrap;

            td {
              max-width: 100%;
            }
          }
        }

      }
    }
  }
}
</style>
